@if (backupModel && backupModel.id > 0) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property"><b>ID:</b> {{ backupModel.identifier }}</div>
                <div class="property text-truncate"><b>Name:</b> {{ backupModel.name }}</div>
            </div>
            <div class="col-6">
                <div class="property"><b>Last modifier:</b> {{ backupModel.lastModifier }}</div>
                <div class="property"><b>Creator:</b> {{ backupModel.creator }}</div>
            </div>
        </div>
    </div>
}

@if (formGroup) {
    <div class="detail-page-card" [formGroup]="formGroup" data-uiid="task-series-detail-form">
        <div class="detail-page-card-title">{{ 'tasks.defineAndManage' | transloco }}</div>
        <div class="detail-page-card-body padded form-group-styling cerrix-task-series-sm">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <cerrix-textfield
                            [fieldLabel]="'tasks.name' | transloco"
                            dataUiid="task-series-detail-name"
                            identifier="taskSeriesNameInput"
                            formControlName="name"
                            [placeholder]="'tasks.requiredPlaceholder' | transloco"
                        ></cerrix-textfield>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="form-group">
                        <label>{{ 'tasks.taskType' | transloco }}</label>
                        <ng-select
                            data-uiid="task-series-linked-type"
                            name="linkedTypes"
                            [multiple]="true"
                            [items]="linkedTypes"
                            [placeholder]="'tasks.requiredPlaceholder' | transloco"
                            formControlName="linkedTypes"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="responsibleSelect">{{ 'tasks.responsibles' | transloco }}</label>
                        <ng-select
                            data-uiid="task-series-responsible"
                            name="responsibleSelect"
                            [multiple]="true"
                            [items]="validResponsibles"
                            [placeholder]="'tasks.requiredPlaceholder' | transloco"
                            formControlName="responsibleIds"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="reviewersSelect">{{ 'tasks.reviewers' | transloco }}</label>
                        <i
                            class="far fa-info-circle mx-2"
                            [matTooltip]="'tasks.reviewersTooltip' | transloco"
                        ></i>
                        <ng-select
                            data-uiid="task-series-reviewers"
                            name="reviewersSelect"
                            [multiple]="true"
                            [items]="validReviewers"
                            formControlName="reviewerIds"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="notificationPeriodSelect">{{ 'tasks.notifications' | transloco }}</label>
                        <ng-select
                            data-uiid="task-series-notification"
                            name="notificationPeriodSelect"
                            [multiple]="true"
                            [items]="validNotificationPeriods"
                            formControlName="notificationPeriodIds"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="form-group col">
                        <label for="scoreOptionsSelect">{{ 'tasks.taskScoreOption' | transloco }}</label>
                        <i
                            class="far fa-info-circle mx-2"
                            [matTooltip]="'tasks.taskScoreTooltip' | transloco"
                        ></i>
                        <ng-select
                            data-uiid="task-series-score-options"
                            name="scoreOptionsSelect"
                            [multiple]="false"
                            [items]="taskScoreOptions"
                            formControlName="taskScoreOption"
                            bindLabel="Name"
                            bindValue="ID"
                            [closeOnSelect]="true"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col">
                    <cerrix-textarea
                        [fieldLabel]="'tasks.description' | transloco"
                        dataUiid="task-series-detail-description"
                        identifier="taskSeriesExecutionDescriptionInput"
                        [rows]="4"
                        formControlName="description"
                    ></cerrix-textarea>
                </div>
            </div>
        </div>
        <div class="detail-page-card">
            <div class="detail-page-card-title-with-subtext">{{ 'tasks.planning' | transloco }}</div>
            @if (model.id > 0) {
                <div class="detail-page-card-subtext">
                    {{ 'tasks.planningSubtext' | transloco }}
                </div>
            }
            <div class="detail-page-card-body padded form-group-styling cerrix-task-series-sm">
                <div class="row">
                    <cerrix-recurrence
                        [parentForm]="formGroup"
                        [model]="recurrenceViewModel"
                        [disableAllExcept]="recurrenceViewModel?.id > 0 ? ['enddate'] : []"
                        #recurrenceComponent
                    ></cerrix-recurrence>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'tasks.details' | transloco }}</div>
        <div class="detail-page-card-body padded cerrix-taskSeries-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    </div>
}
